import Base from './base';

import './component.scss';

export class RetailcrmMobileSubscribe extends Base {
    constructor(id, params = {}, result = {}, options = {}) {
        super(id, params, result, options)

        this.lastTimerId = 0

        this.init()
    }

    init() {
        this.addEventListeners()
    }

    addEventListeners() {
        let self = this

        document.on('click', '.js-mobile-subscribe-show-popup', e => {
            this.showPopup()
        })

        document.on('click', '.js-mobile-subscribe-form-button', e => {
            if (true === this.checkForm()) {
                self.subscribe()
            } else {
                this.showAlert('Для продолжения вам необходимо согласиться на обработку персональных данных', 'error')
            }
        })
    }

    checkForm() {
        let $checkbox = this.$popup.querySelector('.js-agree_checkbox_privacy')

        if (!$checkbox) {
            return true
        }

        if (true === $checkbox.checked) {
            return true
        }

        return false
    }

    async subscribe() {
        let resultData = null,
            email = this.$popup.querySelector('.js-subscribe-form-input').value

        resultData = await this.queryComponent('subscribe', {
            email,
        })

        if (resultData.success === true) {
            if (true === resultData?.subscribeBefore) {
                this.showAlert('Оплачивайте заказ онлайн и получите скидку 5%.')
                this.hidePopup()
            } else {
                this.showAlert('Вам на e-mail направлено письмо с промокодом на скидку 10%.')
                ym(20318386, 'reachGoal', 'mailing')
                this.hidePopup()
            }
        } else {
            this.showAlert(resultData.message, 'error')
        }
    }

    showAlert(text, type = 'success') {
        let $dest = this.$popup.querySelector('.js-mobile-subscribe-alert')
        if (!$dest) {
            return
        }

        $dest.classList.remove('success')
        $dest.classList.remove('error')
        $dest.classList.add(type)

        $dest.innerHTML = text

        $dest.classList.add('show')

        clearTimeout(this.lastTimerId)
        this.lastTimerId = setTimeout(() => {
            $dest.classList.remove('show')
        }, 3500)
    }

    hideAlert() {
        $dest.classList.remove('show')
        $dest.classList.remove('success')
        $dest.classList.remove('error')
        $dest.innerHTML = ''
    }

    showPopup() {
        Fancybox.show(
            [
                {
                    src: `#${this.id}__mobile-subscribe__popup`,
                    type: "inline",
                },
            ],
            {
                mainClass: 'b-mobile-subscribe-popup',
                closeButton: false,
                on: {
                    reveal: (fancybox, slide) => {
                        const closeBtn = slide.$el.querySelector('[data-fancybox-close]');

                        if (closeBtn) {
                            closeBtn.onclick = (e) => {
                                e.preventDefault();
                                fancybox.close();
                            };
                        }
                    },
                },
            }
        );
    }

    hidePopup() {
        clearTimeout(this.lastTimerId)
        this.lastTimerId = setTimeout(() => {
            Fancybox.close()
            this.hideAlert()
        }, 3000)
    }
}
